document.addEventListener('DOMContentLoaded', function () {
  const toolbar = document.querySelector('.results-toolbar');
  if (!toolbar) return;

  // Filter drawer toggle - use event delegation since the button may be replaced by AJAX
  toolbar.addEventListener('click', function (event) {
    const filterToggle = event.target.closest('[data-open-filters]');
    if (!filterToggle) return;

    // Use ID for reliable lookup since drawer may be portaled to OverlayContainer
    const drawer = document.getElementById('ResultsFiltersDrawer');
    if (drawer) {
      const summary = drawer.querySelector('summary');
      if (summary) {
        summary.click();
      }
    }
  });

  // Grid column switching - mobile toggle and desktop buttons
  const mobileGridButtons = toolbar.querySelectorAll('[data-grid-columns-mobile]');
  const desktopGridButtons = toolbar.querySelectorAll('[data-grid-columns-desktop]');

  /**
   * Apply saved grid columns preferences to the product grid
   */
  function applyGridPreference() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    let savedMobileColumns, savedDesktopColumns;
    try {
      savedMobileColumns = localStorage.getItem('results-grid-columns-mobile');
      savedDesktopColumns = localStorage.getItem('results-grid-columns-desktop');
    } catch (e) {
      // localStorage not available
    }

    // Apply mobile/tablet preference
    if (savedMobileColumns) {
      productGrid.className = productGrid.className.replace(/grid--\d-col-tablet-down/g, '');
      productGrid.classList.add('grid--' + savedMobileColumns + '-col-tablet-down');

      mobileGridButtons.forEach(function (btn) {
        const cols = btn.dataset.gridColumnsMobile;
        btn.setAttribute('aria-pressed', cols === savedMobileColumns ? 'true' : 'false');
      });
    } else {
      // Sync buttons with current grid state
      const match = productGrid.className.match(/grid--(\d)-col-tablet-down/);
      const currentMobileColumns = match ? match[1] : '2';

      mobileGridButtons.forEach(function (btn) {
        const cols = btn.dataset.gridColumnsMobile;
        btn.setAttribute('aria-pressed', cols === currentMobileColumns ? 'true' : 'false');
      });
    }

    // Apply desktop preference
    if (savedDesktopColumns) {
      productGrid.className = productGrid.className.replace(/grid--\d-col-desktop/g, '');
      productGrid.classList.add('grid--' + savedDesktopColumns + '-col-desktop');

      desktopGridButtons.forEach(function (btn) {
        const cols = btn.dataset.gridColumnsDesktop;
        btn.setAttribute('aria-pressed', cols === savedDesktopColumns ? 'true' : 'false');
      });
    } else {
      // Sync buttons with current grid state
      const match = productGrid.className.match(/grid--(\d)-col-desktop/);
      const currentColumns = match ? match[1] : '4';

      desktopGridButtons.forEach(function (btn) {
        const cols = btn.dataset.gridColumnsDesktop;
        btn.setAttribute('aria-pressed', cols === currentColumns ? 'true' : 'false');
      });
    }
  }

  // Apply on initial load
  applyGridPreference();

  // Watch for AJAX updates to the product grid container
  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer) {
    const observer = new MutationObserver(function (mutations) {
      // Check if product-grid was replaced
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Re-apply grid preference after AJAX update
          applyGridPreference();
          break;
        }
      }
    });

    observer.observe(productGridContainer, {
      childList: true,
      subtree: true,
    });
  }

  // Handle mobile button clicks
  mobileGridButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const columns = this.dataset.gridColumnsMobile;
      const productGrid = document.getElementById('product-grid');

      // Update grid class for mobile
      if (productGrid) {
        productGrid.className = productGrid.className.replace(/grid--\d-col-tablet-down/g, '');
        productGrid.classList.add('grid--' + columns + '-col-tablet-down');
      }

      // Update button states
      mobileGridButtons.forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });

      // Save preference
      try {
        localStorage.setItem('results-grid-columns-mobile', columns);
      } catch (e) {
        // localStorage not available
      }
    });
  });

  // Handle desktop button clicks
  desktopGridButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const columns = this.dataset.gridColumnsDesktop;
      const productGrid = document.getElementById('product-grid');

      // Update grid class for desktop
      if (productGrid) {
        productGrid.className = productGrid.className.replace(/grid--\d-col-desktop/g, '');
        productGrid.classList.add('grid--' + columns + '-col-desktop');
      }

      // Update button states
      desktopGridButtons.forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });

      // Save preference
      try {
        localStorage.setItem('results-grid-columns-desktop', columns);
      } catch (e) {
        // localStorage not available
      }
    });
  });
});
